<template>
  <div class="terms">
    <header class="terms__header">
      <h2>Money Policy</h2>

      <div class="img" @click="$emit('close')">
        <img :src="mediaBaseUrl + 'close.svg'" alt="close">
      </div>
    </header>

    <subscription-terms-text />
  </div>
</template>

<script>
export default {
  name: "PolicyModal",

  inject: ["mediaBaseUrl"],
}
</script>

<style lang="sass">
.terms .terms__header h2
  margin-bottom: 0
</style>
